import script from "./BookmarkListCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookmarkListCard.vue?vue&type=script&setup=true&lang=ts"

import "./BookmarkListCard.vue?vue&type=style&index=0&id=fce71864&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fce71864"]])

export default __exports__